import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { Meta, UserInfo, getLocalizedLabel, valueNotEmpty, valuePathPrefix, valueIsIntNumber, getmeta, valueIsNumInRange, valueByFormikPath } from '../../common'
import { Container, Segment, Tab, Grid, Dropdown as PureDropdown, Checkbox as PureCheckbox, DropdownItemProps, Menu, Label, Header, FeedMeta } from 'semantic-ui-react'
import Input from '../form/Input'
import Checkbox from '../form/Checkbox'
import TextArea from '../form/TextArea'
import Dropdown from '../form/Dropdown'
import Button from '../form/Button'
import { Field, FieldArray, Formik } from 'formik'
import {ConfigEditorUiEditorCompProps} from './CEUiEditor'
import PathSpec from '../form/PathSpec'
import { setFieldValue } from '../form/FormikHelpers'

class ConfigEditorUiEditorCompFeatureForm extends Component<ConfigEditorUiEditorCompProps> {

    render() {
        const { meta, editing, locale, t, i18n, params, formikprefix, formik, cunitTypes } = this.props
        const lang = i18n.language

        const values = valueByFormikPath(formikprefix, formik.values)

        const featureTypes = Object.keys(meta.cats['feature']).reduce((res: DropdownItemProps[], type) => {
            const u = meta.cats['feature'][type]
            if (!u.subdef_required
                /* this is really complex and may be buggy: we needed to count with prefix overlaps from both sides? */
                    && (!cunitTypes || !u.params.restr_owner || !u.params.restr_owner.cunit_type || u.params.restr_owner.cunit_type.filter((t: string) => 
                        (cunitTypes.includes(t) || cunitTypes.filter(x => x.startsWith(t+':')).length>0 || cunitTypes.filter(x => t.startsWith(x+':')).length>0)
                        ).length>0)
                    ) {
               res.push({key: type, value: type, text: getLocalizedLabel(u.label, lang)+' ['+type+']'})
            }
            return res
        }, [])

        const newFeature = {feature: ''}

        return (
            <>
            <Grid.Row>
                <Grid.Column width={16}><div className="label">{t('Features')}</div></Grid.Column>
            </Grid.Row>                
            <FieldArray name={formikprefix+".params.features"}
                render={(subformik) => (
                    <>
                    {values.params.features.map((item: any, findex: number) => {
                        const fmeta = getmeta(meta, 'feature', item.feature)
                        return (
                            <Grid.Row>
                            <Grid.Column width={10}>
                                <Dropdown name={formikprefix+".params.features."+findex+".feature"} validate={valueNotEmpty}
                                        inputProps={{disabled: !editing}} options={featureTypes}/>
                            </Grid.Column>
                            <Grid.Column width={2}>
                                <Checkbox name={formikprefix+".params.features."+findex+".doc"} label={t('document')} fieldProps={{className: "compactfield"}} 
                                    inputProps={{disabled: !editing || !(fmeta && (!fmeta.params.restr_owner || fmeta.params.restr_owner.cunit))}}/>
                                <Checkbox name={formikprefix+".params.features."+findex+".slot"} label={t('slot')} fieldProps={{className: "compactfield"}} 
                                    inputProps={{disabled: !editing || !(fmeta && (!fmeta.params.restr_owner || fmeta.params.restr_owner.slot))}}/>
                                <Checkbox name={formikprefix+".params.features."+findex+".filler"} label={t('filler')} fieldProps={{className: "compactfield"}} 
                                    inputProps={{disabled: !editing || !(fmeta && (!fmeta.params.restr_owner || fmeta.params.restr_owner.filler))}}/>
                            </Grid.Column>
                            <Grid.Column width={4} textAlign="right">
                                { editing ? 
                                <>
                                <Button type="button" icon="angle up" color="blue" size="mini"
                                    disabled={!editing || findex === 0}
                                    onClick={(e,d) => subformik.swap(findex, findex-1)}/>
                                <Button type="button" icon="angle down" color="blue" size="mini"
                                    disabled={!editing || findex === values.params.features.length-1}
                                    onClick={(e,d) => subformik.swap(findex, findex+1)}/>
                                <Button type="button" icon="delete" color="red" size="mini"
                                    disabled={!editing}
                                    onClick={(e,d) => subformik.remove(findex)}/>
                                </> : null}
                            </Grid.Column>
                            </Grid.Row>
                        )
                    })}
                    <Grid.Row>
                        <Grid.Column width={16}>
                        { editing ? <Button icon="plus" type="button" size="tiny" color='blue' 
                            onClick={(e,d) => subformik.push(newFeature)} disabled={!editing}/> : null}
                        </Grid.Column>
                    </Grid.Row>
                    </>
                    )
                }/>
            </>
        )
    }
}

export default withTranslation()(ConfigEditorUiEditorCompFeatureForm)